<button #btn class="{{style}}" [ngClass]="buttonStyle" [disabled]="disabled" (click)="onCLick.emit()" [title]="hint" [type]="type">
  <img *ngIf="icon" src="{{ icon | iconByName }}"/>
  <span *ngIf="title">{{title}}</span>
</button>